import * as React from "react";
import { StyleSheet, TouchableOpacity, View } from "react-native";
import { FontAwesome } from '@expo/vector-icons';
import Colors from "../utilities/Color.js";
import { useNavigation } from "@react-navigation/native";

export default function favouriteIcon({isFavorite, offerId}) {
  const navigation = useNavigation();
  return (
    <View style={styles.favouriteIconContainer}>
      <TouchableOpacity
        style={styles.iconContainer}
        onPress={ () => {
            navigation.navigate("WebBuyAction")
          }}
      >
        <FontAwesome name= "bookmark-o"  size={22} color={Colors.WHITE} />
      </TouchableOpacity>
    </View>
  );
}
const styles = StyleSheet.create({})